<template>
    <button class="btn btn-outline green" v-on:click="nextPage()">
        View more
    </button>
</template>

<script>
    export default {
        data() {
            return { }
        },

        methods: {
            nextPage: function () {
                this.$store.dispatch('updateSearchFilter', { key: 'page', value: this.$store.state.search.filters.page + 1 })

                this.$eventHub.$emit('search-pageChanged')
            }
        }
    }
</script>